<script>
  import TextArea from "./textArea.svelte"
  /**
   * @type {String} Represents a name of the font.
   */
  export let fontName = ""
  /**
   * @type {String} For preview in font.
   */
  let link = "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Commodi quisquam beatae at similique repudiandae vero impedit aliquid ullam dignissimos cumque veniam accusamus laborum eveniet perspiciatis, amet officia dolor ea excepturi."
  /**
   * @type {String} The active item value like normal/bold/italic....
   */
  let activeItem = "Normal"
  /**
   * @type {Boolean} Specifies whether the content is editable or not for text area....
   */
  let contentEditable = false
</script>

<div>
  <div class="flex h-full items-center justify-between pb-3">
    <h1 class="text-lg font-bold tracking-wide text-slate-100">Font Preview</h1>
    <div class="flex gap-3">
      <button
        on:click={() => {
          activeItem = "Normal"
        }}
        data-tooltip="Normal"
        tooltip-position="top"
        class="flex items-center {activeItem == 'Normal' ? 'bg-zinc-800 ring-2 ring-extraBlue-500 active:bg-extraBlue-500' : 'bg-transparent'} rounded-md border border-stone-700 bg-transparent p-2 text-lg text-gray-g00 hover:bg-zinc-900 focus:outline-none"
      >
        <span class="flex h-5 w-5 items-center justify-center">
          <i class="fa-solid fa-n" />
        </span>
      </button>
      <button
        on:click={() => {
          activeItem = "Bold"
        }}
        data-tooltip="Bold"
        tooltip-position="top"
        class="flex items-center {activeItem == 'Bold' ? 'bg-zinc-800 ring-2 ring-extraBlue-500 active:bg-extraBlue-500' : 'bg-transparent'} rounded-md border border-stone-700 bg-transparent p-2 text-lg text-gray-g00 hover:bg-zinc-900 focus:outline-none"
      >
        <span class="flex h-5 w-5 items-center justify-center">
          <i class="fa-solid fa-bold" />
        </span>
      </button>
      <button
        on:click={() => {
          activeItem = "Italic"
        }}
        data-tooltip="Italic"
        tooltip-position="top"
        class="flex items-center {activeItem == 'Italic' ? 'bg-zinc-800 ring-2 ring-extraBlue-500 active:bg-extraBlue-500' : 'bg-transparent'} rounded-md border border-stone-700 bg-transparent p-2 text-lg text-gray-g00 hover:bg-zinc-900 focus:outline-none"
      >
        <span class="flex h-5 w-5 items-center justify-center">
          <i class="fa-solid fa-italic" />
        </span>
      </button>
    </div>
  </div>
  <TextArea {fontName} {contentEditable} {link} {activeItem} />
</div>

<style lang="postcss">
  .option-class {
    @apply w-full border-b border-[#242424]/50 bg-[#2F2F2F] px-3 py-1.5 text-sm font-bold text-slate-300 hover:text-blue-500;
  }
</style>
